import { connect } from 'react-redux'
import ChatList from '../components/ChatList'
import { getChats } from '../api'
import { isLoading, chatListDataLoad } from '../actions'

const mapStateToProps = state => {
  return {
    // props to App Component..
    chats: state.chats,
    isLoading: state.isLoading
  }
}

const mapDispatchToProps = dispatch => {
  return {
    // props to App Component
    onLoad() {
      dispatch(isLoading())

      getChats().then(data => {
        dispatch(chatListDataLoad(data))
      })
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(/* component */ ChatList)
